// extracted by mini-css-extract-plugin
var _1 = "Button-module__commonButtonClass__AK_8c";
var _2 = "Button-module__danger__MNIMq";
var _3 = "Button-module__info__o8vWZ";
var _4 = "Button-module__light__wtRlg";
var _5 = "Button-module__success__P3z29";
export { _1 as "commonButtonClass", _2 as "danger", _3 as "info", _4 as "light", _5 as "success" }
